// extracted by mini-css-extract-plugin
export var actions = "_tl-4";
export var item = "_tl-1";
export var price = "_tl-3";
export var quantity = "_tl-2";
export var table = "_tl-0";